export const INITIALIZE = "INITIALIZE"
export const UPDATE_FORM_STATE = "UPDATE_FORM_STATE"

export const Initialize = ( closeForm)=>{    
    return {type: INITIALIZE,  closeForm }
}

export const UpdateFormState = (isDirty)=>{
    return {type:UPDATE_FORM_STATE, isDirty}

}
